<template>
  <v-layout row justify-end>
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t('AdministrationEditUserPasswordDialog.editTitleMsg') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="clearForm()" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-form v-model="valid" ref="form" lazy-validation style="width: 100%">
          <v-card-text>
            <v-layout pa-5>
              <v-flex xs12>
                <v-text-field label="New Password" v-model="password" :rules="passwordRules" type="password"></v-text-field>
                <v-text-field label="Confirm Password" v-model="confirmPassword" :rules="comfirmRules" type="password"></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="submit()">
              <v-icon class="mr-1">done</v-icon>
              {{ $t('Button.Save') }}
            </v-btn>
            <v-btn color="secondary" outline @click="clearForm()">{{ $t('Button.Close') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-card color="grey lighten-4">
      <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
        {{ snackMessage }}
        <v-btn dark flat @click.native="snackbar = false">{{ $t('Button.Close') }}</v-btn>
      </v-snackbar>
    </v-card>
  </v-layout>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const {
    mapActions,
  } = createNamespacedHelpers('admin')

  export default {
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      userDetail: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        dialog: '',
        snackbar: '',
        snackColor: '',
        snackMessage: '',
        valid: true,

        editUserData: {},
        password: '',
        confirmPassword: '',
        userRole: null,

        passwordRules: [
          (v) => !!v && v.length >= 6 || 'Password at least 6 characters',
        ],
        comfirmRules: [
          (v) => this.password == v || 'The passwords entered are not the same',
        ],
      }
    },
    mounted() {},
    computed: {},
    watch: {
      show() {
        this.dialog = true
        this.editUserData = JSON.parse(JSON.stringify(this.userDetail))
      },
    },
    methods: {
      ...mapActions(['postEditUserPassword']),
      submit() {
        if (this.$refs.form.validate()) {
          let options = {
            data: {
              UserName: this.userDetail.UserName,
              NewPassword: this.password,
            },
            successCb: () => {
              this.snackMessage = this.$t('AdministrationEditUserPasswordDialog.saveSuccessMsg')
              this.snackColor = 'success'
              this.snackbar = true
              this.clearForm()
            },
            failedCb: (err) => {
              this.snackColor = 'error'
              this.snackMessage = err
              this.snackbar = true
            },
          }
          this.postEditUserPassword(options)
        }
      },
      clearForm() {
        this.$refs.form.reset()
        this.dialog = false
      },
    },
  }
</script>